import classNames from 'classnames';
import React from 'react';
import sessionStore from 'client/Session/SessionStore';

import {QuestionModelV1} from '@albert-io/models';

import {Icon, Text} from '@albert-io/atomic';

import {SaveStatus} from 'client/components/QuestionTypes/QuestionType.types';

import QuestionTypeStore from 'client/components/QuestionTypes/QuestionType.store';

import './question-actions-wrapper.scss';
import {IssuesModalButton} from 'client/Modals/IssuesModal/IssuesModalButton';

import NewTranslationToggle from 'client/NewTranslationToggle/NewTranslationToggle';
import {hasZustand} from 'client/components/QuestionTypes/V2/useQuestionStores';
import useQuestionAndDrafts from 'client/components/QuestionTypes/V2/useQuestionAndDrafts.hook';
interface Props extends PropsWithClassNameOptional, PropsWithChildrenRequired {
  activeQuestion?: QuestionModelV1;
  questionId: string;
  showTranslationToggle?: boolean;
}

export default function QuestionActionsWrapper({
  questionId,
  activeQuestion,
  children,
  className,
  showTranslationToggle = false
}: Props) {
  const activeQuestionStore = activeQuestion?.getStore();

  // TODO: use custom hook to get this

  const {
    hasDraftGuess: zHasDraftGuess,
    isSubmitted,
    getDraftStatusCode
  } = useQuestionAndDrafts(activeQuestion);

  const hasError =
    activeQuestionStore !== undefined &&
    (hasZustand(activeQuestionStore)
      ? getDraftStatusCode() === SaveStatus.SAVE_ERROR
      : activeQuestionStore.getSaveStatus() === SaveStatus.SAVE_ERROR);

  const hasDraftGuess =
    activeQuestionStore !== undefined &&
    (hasZustand(activeQuestionStore)
      ? zHasDraftGuess
      : activeQuestionStore.getHasDraftGuess() &&
        !activeQuestionStore.getDraftGuess().isDraftGuessEmpty());

  let bannerText = <Text color='secondary'>No answer saved.</Text>;

  if (hasError) {
    bannerText = (
      <Text color='negative'>Your answer was not saved. Please refresh your browser.</Text>
    );
  } else if (hasDraftGuess || isSubmitted) {
    bannerText = (
      <Text color='tertiary'>
        <Text color='secondary'>Answer saved</Text> and will be submitted with your assignment.
      </Text>
    );
  }

  const showFeedbackButton = sessionStore.hasValidSession();

  return (
    <div className={classNames(className, 'question-actions-wrapper')}>
      {!QuestionTypeStore.shouldNotSaveDraft() && (
        <div
          className={classNames('question-actions-wrapper__draft-guess-status', {
            'question-actions-wrapper__draft-guess-status--error': hasError,
            'question-actions-wrapper__draft-guess-status--has-draft-guess':
              !hasError && (hasDraftGuess || isSubmitted)
          })}
        >
          {hasError && (
            <div className='question-actions-wrapper__draft-guess-status-icon-wrapper'>
              <Icon color='negative' icon={['far', 'cloud-slash']} />
            </div>
          )}
          {bannerText}
        </div>
      )}
      <div className='flex justify-end gap-x1 px-x3 py-x2'>
        <div className='flex w-full items-center justify-between'>
          <div className='flex items-center'>
            {showFeedbackButton && <IssuesModalButton questionId={questionId} />}
            {showTranslationToggle && (
              <NewTranslationToggle
                light
                popoverPlacement='top-start'
                variant='IconButton'
                viewType='assignment-builder'
              />
            )}
          </div>
          <div className='flex gap-x1'>{children}</div>
        </div>
      </div>
    </div>
  );
}
